function IndicatorSeparator() {
  return null;
}

export default IndicatorSeparator;
